import { UserLiteDTO } from 'src/app/common/state/user/user.dto';
import { CelebrationDTO } from './celebrations.dto';

// present on COMMENT_ON_PLAN notifications so they can deep-link to the
// specific deliverable/action item that was commented on, not just the plan
export interface PlanCommentNotificationContext {
  phase_id: number;
  deliverable_id: number;
  action_item_id?: number;
  // this plan's custom label for "deliverable"/"action item" (e.g. "Objective"), captured
  // at notification-creation time so it stays a snapshot even if the plan's labels change later
  displayname?: string;
}

export interface NotificationDTO {
  created_at: number;
  date_shown: number | null;
  id: number;
  notification_date: number;
  notification_message: string;
  notification_ref_id: number;
  notification_context?: PlanCommentNotificationContext | null;
  notification_type: NotificationType;
  updated_at: number;
  user_id: number;
  actor_user_id: number | null;
  actorUser?: UserLiteDTO;
  // add more DTOs here as notification types expand
  notificationDetails?: CelebrationDTO;
  markedRead?: boolean;
}

// add more notification types here
export enum NotificationType {
  CELEBRATION = 'celebration',
  COMMENT_ON_LOG = 'comment_on_log',
  COMMENT_ON_PLAN = 'comment_on_plan',
  COMMENT_ON_EVIDENCE = 'comment_on_evidence',
}
